import React, { useState } from "react";
import "../pages/Login.css";
import {login} from "../services/authService"
import { validateLogin } from "../utils/validate";
import { useNavigate } from "react-router-dom";
import {AlertModal} from "../components/AlertModal/AlertModal";

export default function Login() {

    const navigate =  useNavigate();

    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [errors, setErrors] = useState({});
    const [serverError, setServerError] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [message, setMessage] = useState("")
    const [color, setColor] = useState("")

    const handleLogin = async (e) =>{
        e.preventDefault();
        const validationErrors = validateLogin(username, password);
        if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
        }
        
        const response = await login(username,password)

        if(response.success){
            // setMessage("Login successful!");
            //console.log(response);
            navigate("/")
        }
        else{
            setShowAlert(true)
            setColor("red")
            setMessage(response.error);
        }
        
    
        
    }

    return (
        <div className="login-container">
            {showAlert && (
        <AlertModal
          message={message}
          color={color}
          onClose={() => {
            setShowAlert(false)
            setMessage("")
            setColor("")
          }}
        />
      )}
        <div className="login-card">
            <div className="logo-container">
            <img 
                src="logo.png" 
                alt="Company Logo" 
                className="logo-image"
            />
            </div>
            <h2 className="login-title">eBadge Distribution</h2>
            <div className="input-group">
            <form onSubmit={handleLogin}>
            <div className="input-wrapper">
                <span className="input-icon">👤</span>
                <input type="text" placeholder="Username" className="login-input" onChange={(e) =>setUsername(e.target.value)}/>
                {errors.username && <p style={{color:"red"}}>{errors.username}</p>}
            </div>
            <div className="input-wrapper">
                <span className="input-icon">🔒</span>
                <input type="password" placeholder="Password" className="login-input" onChange={(e)=>setPassword(e.target.value)}/>
                {errors.password && <p style={{color:"red"}}>{errors.password}</p>}
            </div>
            <button className="login-button" >Login</button>
            {/* <p className="register-text">
                Don't have an account? <a href="/signup" className="register-link">Register</a>
            </p> */}
            </form>
            </div>
        </div>
        </div>
    );
}